<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>

html, body {
  margin: 0;
  scroll-behavior: smooth; 
  font-family: 'Segoe UI', sans-serif;
  font-weight: 500;
  }
</style>
